'use client';
import { useEffect, useState } from 'react';
import { PrismicNextImage } from '@prismicio/next';
import type { ImageFieldImage } from '@prismicio/client';

type ImgixParams = Record<string, string | number | boolean | string[] | undefined>;

interface ResponsivePrismicImageProps {
    image: ImageFieldImage & {
        mobile?: ImageFieldImage;
        desktop?: ImageFieldImage;
    };
    className?: string;
    sizes?: string;
    priority?: boolean;
    imgixParams?: ImgixParams;
}

const DEFAULT_IMGIX_PARAMS: ImgixParams = {
    auto: ['compress'],
    fm: 'webp',
    q: 45,
    fit: 'max',
};

const ResponsivePrismicImage: React.FC<ResponsivePrismicImageProps> = ({ image, className, sizes = "100vw", priority = false, imgixParams }) => {
    const [selectedImage, setSelectedImage] = useState<ImageFieldImage | null>(image);

    useEffect(() => {
        const update = () => {
            if (!image) return;
            const width = window.innerWidth;
            if (width <= 1024 && image.mobile?.url) {
                setSelectedImage(image.mobile);
            } else {
                setSelectedImage(image);
            }
        };

        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, [image]);

    if (!selectedImage || !selectedImage.url) return null;

    return (
        <PrismicNextImage
            field={selectedImage}
            className={className}
            fallbackAlt=""
            sizes={sizes}
            priority={priority}
            imgixParams={{ ...DEFAULT_IMGIX_PARAMS, ...(imgixParams || {}) }}
        />
    );
}

export default ResponsivePrismicImage
